'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _OMDropdown = require('./OMDropdown.scss');var styles = _interopRequireWildcard(_OMDropdown);
var _isDescendant = require('../../../utils/isDescendant');var _isDescendant2 = _interopRequireDefault(_isDescendant);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // styles
var
OMDropdown = function (_Component) {_inherits(OMDropdown, _Component);function OMDropdown() {var _temp, _this, _ret;_classCallCheck(this, OMDropdown);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isCollapsed: false }, _this.












    getRef = function (ref) {_this.wrapper = ref;}, _this.

    handleClick = function (evt) {
      if (!_this.state.isCollapsed || (0, _isDescendant2.default)(_this.wrapper, evt.target)) {
        return undefined;
      }

      return _this.setState({ isCollapsed: false });
    }, _this.

    handleSelect = function (evt) {
      var id = (0, _get2.default)(evt, 'currentTarget.dataset.id');
      _this.props.handleSelect(id);
    }, _this.

    toggleCollapse = function () {return _this.setState({ isCollapsed: !_this.state.isCollapsed });}, _this.

    renderOption = function (_ref) {var _cx;var id = _ref.id,label = _ref.label;return (
        _react2.default.createElement('div', {
            key: id,
            'data-id': id,
            onClick: _this.handleSelect,
            className: (0, _classnames2.default)(
            styles.option, (_cx = {}, _cx[
            styles.selected] = id === (_this.props.selectedOption && _this.props.selectedOption.id), _cx)) },


          label));}, _this.



    renderArrow = function () {return _this.props.isTab &&
      _react2.default.createElement('span', { className: 'icon icon-caret-down' });}, _temp), _possibleConstructorReturn(_this, _ret);}OMDropdown.prototype.componentWillMount = function componentWillMount() {if (global && global.window) {window.addEventListener('mouseup', this.handleClick);}};OMDropdown.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('mouseup', this.handleClick);};OMDropdown.prototype.


  render = function render() {var _cx2, _cx3, _cx4;var _props =
    this.props,isTab = _props.isTab,selectedOption = _props.selectedOption;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          styles.wrapper, (_cx2 = {}, _cx2[
          styles.opened] = this.state.isCollapsed, _cx2), (_cx3 = {}, _cx3[
          styles.tab] = isTab, _cx3), (_cx4 = {}, _cx4[
          styles.selectedTab] = isTab && !!selectedOption, _cx4)),

          onClick: this.toggleCollapse,
          ref: this.getRef },

        _react2.default.createElement('div', { className: styles.placeholder },
          !isTab && _react2.default.createElement('div', null, selectedOption.label),
          _react2.default.createElement('div', null, this.props.callToAction, this.renderArrow())),

        _react2.default.createElement('div', { className: styles.optionsWrapper },
          this.props.options.map(this.renderOption))));



  };return OMDropdown;}(_react.Component);


OMDropdown.propTypes = {
  options: _propTypes2.default.array,
  handleSelect: _propTypes2.default.func,
  callToAction: _propTypes2.default.string,
  selectedOption: _propTypes2.default.object,
  isTab: _propTypes2.default.bool };exports.default =


OMDropdown;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMDropdown/OMDropdown.js
// module id = 1217
// module chunks = 0